import { render, staticRenderFns } from "./line-chart.vue?vue&type=template&id=524d335f&scoped=true&"
import script from "./line-chart.vue?vue&type=script&lang=js&"
export * from "./line-chart.vue?vue&type=script&lang=js&"
import style0 from "./line-chart.vue?vue&type=style&index=0&id=524d335f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d335f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\projects\\tesas_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('524d335f', component.options)
    } else {
      api.reload('524d335f', component.options)
    }
    module.hot.accept("./line-chart.vue?vue&type=template&id=524d335f&scoped=true&", function () {
      api.rerender('524d335f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/line-chart.vue"
export default component.exports